<template>
  <Head :title="itemAsset ? itemAsset.item_name : 'Item Asset Info'" />
  <MobileLayout :auth="auth" :version="version">
    <div class="max-w-md mx-auto bg-white rounded-lg shadow-md overflow-hidden md:max-w-2xl">
      <div v-if="itemAsset" class="md:flex">
        <div class="p-8 w-full">
          <div class="uppercase tracking-wide text-sm text-indigo-500 font-semibold">
            Item Asset
          </div>
          <h1 class="block mt-1 text-lg leading-tight font-medium text-black">
            {{ itemAsset.item_name }}
          </h1>
          <p class="mt-2 text-gray-500">
            Asset No: {{ itemAsset.asset_no }}
          </p>
          <p class="mt-2 text-gray-500">
            Serial Num: {{ itemAsset.serial_num }}
          </p>
          <p class="mt-2 text-gray-500">
            Condition: {{ itemAsset.condition }}
          </p>
          <p class="mt-2 text-gray-500">
            Project: {{ itemAsset.project_name }}
          </p>

          <!-- Detailed Info (for logged-in users) -->
          <div v-if="auth.user" class="mt-6 border-t border-gray-200 pt-4">
            <div class="uppercase tracking-wide text-sm text-indigo-500 font-semibold">
              Detailed Information
            </div>
            <p class="mt-2 text-gray-500">
              Employee: {{ itemAsset.employee_name }}
            </p>
            <p class="mt-2 text-gray-500">
              Location: {{ itemAsset.item_location_name }}
            </p>
            <p class="mt-2 text-gray-500">
              Purchase Date: {{ itemAsset.purchase_date }}
            </p>
            <p class="mt-2 text-gray-500">
              Purchase Price: {{ formatNumber(itemAsset.purchase_price) }}
            </p>
            <p class="mt-2 text-gray-500">
              Status: {{ itemAsset.status }}
            </p>
            <p class="mt-2 text-gray-500">
              Ownership: {{ itemAsset.asset_ownership }}
            </p>
            <p class="mt-2 text-gray-500">
              Description: {{ itemAsset.desc }}
            </p>
          </div>
        </div>
      </div>
      <div v-else class="p-8 text-center text-gray-500">
        <p>Item Asset not found or invalid QR code.</p>
      </div>
    </div>
  </MobileLayout>
</template>

<script setup>
import { defineProps } from 'vue'
import { Head } from '@inertiajs/vue3'
import MobileLayout from '@/Shared/MobileLayout.vue'

defineProps({
    itemAsset: Object, // Can be null if not found
    auth: Object, // Passed from Inertia, contains user info if logged in
    version: String, // Passed from Inertia shared data
})

function formatNumber (num) {
    return num ? num.toLocaleString('id-ID') : '0'
}
</script>
